module.exports = __webpack_public_path__ + "assets/img/1.dff7cf8d.png";